// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"705c248e","703":"6299de62","787":"7418f540"}[chunkId] + ".chunk.js";
};